import { createTheme } from '../../../packages/theme/dist/theme.esm.js';
import * as alert from './pebbleComponentToken/alert.js';
import * as button from './pebbleComponentToken/button.js';
import * as card from './pebbleComponentToken/card.js';
import * as cascader from './pebbleComponentToken/cascader.js';
import * as checkbox from './pebbleComponentToken/checkbox.js';
import * as datePicker from './pebbleComponentToken/date-picker.js';
import * as drawer from './pebbleComponentToken/drawer.js';
import * as dropdown from './pebbleComponentToken/dropdown.js';
import * as input from './pebbleComponentToken/input.js';
import * as inputNumber from './pebbleComponentToken/input-number.js';
import * as menu from './pebbleComponentToken/menu.js';
import * as message from './pebbleComponentToken/message.js';
import * as modal from './pebbleComponentToken/modal.js';
import * as notification from './pebbleComponentToken/notification.js';
import * as pagination from './pebbleComponentToken/pagination.js';
import * as popover from './pebbleComponentToken/popover.js';
import * as radio from './pebbleComponentToken/radio.js';
import * as select from './pebbleComponentToken/select.js';
import * as slider from './pebbleComponentToken/slider.js';
import * as steps from './pebbleComponentToken/steps.js';
import * as _switch from './pebbleComponentToken/switch.js';
import * as table from './pebbleComponentToken/table.js';
import * as tabs from './pebbleComponentToken/tabs.js';
import * as tag from './pebbleComponentToken/tag.js';
import * as treeSelect from './pebbleComponentToken/tree-select.js';
import * as typography from './pebbleComponentToken/typography.js';
import * as index from './pebbleGlobalToken/index.js';

/**
 * 获取theme base token 应用于所有主题
 */
var getTheme = function getTheme() {
  return createTheme({
    globalToken: index,
    componentToken: {
      alert: alert,
      // breadcrumb: pebbleBreadcrumbToken,
      button: button,
      card: card,
      checkbox: checkbox,
      datePicker: datePicker,
      drawer: drawer,
      dropdown: dropdown,
      input: input,
      inputNumber: inputNumber,
      menu: menu,
      message: message,
      notification: notification,
      pagination: pagination,
      popover: popover,
      radio: radio,
      select: select,
      slider: slider,
      "switch": _switch,
      table: table,
      tabs: tabs,
      tag: tag,
      treeSelect: treeSelect,
      modal: modal,
      steps: steps,
      typography: typography,
      cascader: cascader
      // avatar: pebbleAvatarToken,
    }
  });
};

export { getTheme };
